import React from 'react'

function AccordionItem({ item, index, level = 1, isLast = false, ...props }) {
  const [isActivated, setIsActivated] = React.useState(false);
  const setOrToggleActive = () => {
    setIsActivated(!isActivated)
  };

  const renderContent = () => {
    if (level === 1 && item.data) {
      return item.data.map((nestedItem, nestedIndex) => {
        const isLast = nestedIndex === item.data.length - 1;
        return (
          <AccordionItem
            item={nestedItem}
            index={nestedIndex}
            level={2}
            isLast={isLast}
          />
        );
      });
    } else if (level === 2 && item.data) {
      return item.data.map((nestedItem, nestedIndex) => {
        const isLast = nestedIndex === item.data.length - 1;
        return (
          <AccordionItem
            item={nestedItem}
            index={nestedIndex}
            level={3}
            isLast={isLast}
          />
        );
      });
    } else {
      return <div className="p-4" dangerouslySetInnerHTML={{ __html: item.text }}></div>;
    }
  };

  return (
    <div className={`border-black ${isLast ? "" : "border-b-[2px]"}  transition-all  `} {...props}>
      <div
        className={`flex justify-between 
        items-center p-4 cursor-pointer ${level === 1 ? "bg-blue-500/30 shadow-lg mb-0" : level === 2 && item.data ? "bg-blue-500/50 border-b-1 mt-2 border-black shadow-lg mb-0" : "bg-white"}`}
        onClick={setOrToggleActive}>
        <h3 className="text-lg font-bold ">{item.title}</h3>
        <div className="w-6 h-6 flex items-center justify-center">
          <i className={`fas fa-chevron-${isActivated ? 'up' : 'down'}`}></i>
        </div>
      </div>
      <div className={`transition-all overflow-hidden ${isActivated ? 'h-auto' : 'h-0 '}`}>{renderContent()}</div>
    </div>
  )
}

export default AccordionItem;
